import { createApp } from 'vue'
import App from './App.vue'

// Import global styles
import './assets/main.css'

const app = createApp(App)

app.mount('#app')